<template>
  <div class="page-back-img page" :style="{backgroundImage: 'url(' + backUrl + ') !important'}">
		<router-view transition="fade" transition-mode="out-in"></router-view>
  </div>
</template>

<script type="text/babel">
 /* eslint-disable */
import './assets/js/zepto.min.js'
import './assets/js/sm.min.js'
import CommonFunc from './components/common/common'

// 关闭SUI的路由
$.config = {
  router: false
}

export default {
  data () {
    return {
      backUrl: ''
    }
  },

  ready () {

  },
  created() {
    if(this.$route && this.$route.query && this.$route.query.wechatId){
      let wechatId = this.$route.query.wechatId
      let companyKey = this.$route.query.key
      let thirdId = this.$route.query.thirdId

      let employeeInfo = CommonFunc.getEmployeeInfoStore()
      if(!employeeInfo) {
        employeeInfo = {}
      }
      employeeInfo['companyKey'] = companyKey
      employeeInfo['wechatId'] = wechatId
      employeeInfo['thirdId'] = thirdId
      CommonFunc.setEmployeeInfoStore(employeeInfo)
      $.ajax({
        type: 'get',
        url: '/api/wechat/employeeInfo',
        dataType: 'json',
        headers: {
          'x-wechat-id': wechatId,
          'x-third-id': thirdId,
          'x-company-key': companyKey,
          'x-plat-type': 'wechat'
        },
        contentType: 'application/json',
        success: function (resp) {
          if (resp.code > 0) {
            CommonFunc.setTokenStore(resp.token)
            if(resp.employeeInfo) {
              let userInfo= resp.employeeInfo
              let employeeInfo = CommonFunc.getEmployeeInfoStore()

              employeeInfo['employeeName'] = userInfo.employeeName
              employeeInfo['departmentName'] = userInfo.departmentName
              employeeInfo['departmentId'] = userInfo.departmentId
              employeeInfo['phone'] = userInfo.mobile
              employeeInfo['employeeId'] = userInfo.employeeId
              employeeInfo['companyName'] = userInfo.companyName
              employeeInfo['companyCode'] = userInfo.companyCode
              employeeInfo['salarys'] = userInfo.salarys
              employeeInfo['companyLogo'] = userInfo.companyLogo
              employeeInfo['companyId'] = userInfo.companyId
              employeeInfo['userId'] = userInfo.userId
              employeeInfo['userRoleId'] = userInfo.userRoleId
              employeeInfo['userRole'] = userInfo.role
              employeeInfo['workCode'] = userInfo.workCode
              employeeInfo['cpSalaryComment'] = userInfo.cpSalaryComment
              CommonFunc.setEmployeeInfoStore(employeeInfo)
              // 默认背景图
              const defaultBackImg = 'http://jx-resource.oss-cn-hangzhou.aliyuncs.com/jx-assets/salary-fantasy/jx-back.png';
              this.$set('backUrl', resp.employeeInfo.companyBack || defaultBackImg);
              let routePath = '/wxjeeshare'
              if(resp.employeeInfo.companyPath) {
                routePath = routePath + '/' + resp.employeeInfo.companyPath
              }
              routePath = routePath + '/search'
              this.$route.router.go({path: routePath, replace: true, query: {wechatId: wechatId, key: companyKey, thirdId: thirdId, platType: 'wechat'}})
            }else{
              //$('.page-back-img').css('backgroundImage', 'url(' + backUrl + ') !important')
              this.$route.router.go({path: '/wxjeeshare/register', replace: true, query: {wechatId: wechatId, key: companyKey, thirdId: thirdId, platType: 'wechat'}})
            }
          } else {
            $.toast(resp.message)
          }
        }.bind(this)
      })
    }else{
      this.$set('backUrl', 'http://jx-resource.oss-cn-hangzhou.aliyuncs.com/jx-assets/salary-fantasy/jx-back.png')
    }
  }
}
</script>

<style>
@import './assets/css/sm.css';

.page-back-img{
    background-repeat: no-repeat;
    -webkit-background-size: 100% 100% !important;
    -moz-background-size: 100% 100% !important;
    -o-background-size: 100% 100% !important;
    background-size: 100% 100% !important;
}

#app{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// App.vue?3bba7e07